import React from 'react';
import AltIso from 'alt/utils/AltIso';
import FinishShiftHeader from '../components/FinishShiftHeader';
import FinishShiftStep1 from '../components/FinishShiftStep1';
import FinishShiftStep2 from '../components/FinishShiftStep2';
import withRouter from '../utils/with-router';
import moment from 'moment';

import connectToStores from 'alt/utils/connectToStores';

import SeoActions from '../actions/SeoActions';
import CandidateActions from '../actions/CandidateActions';
import ShiftStore from '../stores/ShiftStore';
import ShiftActions from '../actions/ShiftActions';
import CandidateStore from '../stores/CandidateStore';
import ReportStore from '../stores/ReportStore';
import ReportActions from '../actions/ReportActions';


@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Finish shift');
            resolve();
        }),

        ShiftStore.getShift(props.params.shiftId),
        CandidateStore.getCandidates(props.params.shiftId),
        ReportStore.getReports(props.params.shiftId)
    ]);
})

@connectToStores
@withRouter
class FinishShift extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeStep: 1,
            lastCompletedStep: 1
        };
    }

    componentDidMount() {
        const shift = this.props.sStore.detailShift;
        if(Object.keys(shift).length && ((moment(shift.end_time) > moment() && shift.status !== 'ended') || shift.status == 'finished')) {
            this.context.router.transitionTo('agenda');
        }
    }

    componentWillReceiveProps(nextProps) {
        const shift = nextProps.sStore.detailShift;
        const candidatesLoaded = nextProps.cStore.candidatesLoaded;
        if(Object.keys(shift).length && ((moment(shift.end_time) > moment() && shift.status !== 'ended') || shift.status == 'finished')) {
            this.context.router.transitionTo('agenda');
        }
        if (!this.props.cStore.candidatesLoaded && candidatesLoaded && nextProps.cStore.candidates.filter(candidate => {return candidate.hiring.status == DJ_CONST.HIRING_STATUSES.HIRED}).length === 0) {
            CandidateStore.getCandidates(this.props.params.shiftId);
            this.setState({activeStep: 2, lastCompletedStep: 2});
        }
    }

    componentWillUnmount() {
        ReportActions.clearReports();
        ShiftActions.clearDetailShift();
        CandidateActions.clearCandidates();
    }

    static getPropsFromStores() {
        return {
            sStore: ShiftStore.getState(),
            cStore: CandidateStore.getState(),
            rStore: ReportStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, CandidateStore, ReportStore];
    }

    stepHeaderClick(i) {
        if (i==2) {
            CandidateStore.getCandidates(this.props.params.shiftId);
        }
        this.setState({
            activeStep: i,
            lastCompletedStep: i > this.state.lastCompletedStep ? i : this.state.lastCompletedStep
        });
    }

    render() {
        const shift = this.props.sStore.detailShift;
        const reports = this.props.rStore.reports;
        const reportsReceived = this.props.rStore.reportsReceived;
        const candidatesReceived = this.props.cStore.candidatesLoaded;
        let candidates = [];
        if (candidatesReceived) {
            candidates = this.props.cStore.candidates.filter(candidate => {
                return [DJ_CONST.HIRING_STATUSES.HIRED, DJ_CONST.HIRING_STATUSES.CANCELLED, DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US].indexOf(candidate.hiring.status) >= 0;
            });
        }
        const firstStepCandidates = candidates.filter(candidate => {return candidate.hiring.status == DJ_CONST.HIRING_STATUSES.HIRED});

        return (
            <div className="view-finish-shift">
                <FinishShiftHeader shift={shift} />

                <div className="view-content maxwidth-wrapper">

                    <div className="accordion whitebox">
                        <div className={"accordion-item finish-shift-step" + (this.state.activeStep == 1 ? " active" : "")}>

                            <button onClick={firstStepCandidates.length === 0 ? evt => evt.preventDefault() : this.stepHeaderClick.bind(this, 1)} className="accordion-item-header">
                                <span className="step-nr">1</span>
                                <h2 className="step-title">Rate people</h2>
                            </button>

                            <FinishShiftStep1 nextHeader={this.stepHeaderClick.bind(this, 2)} shiftId={shift.id}
                                              candidates={reportsReceived && candidatesReceived ? firstStepCandidates : null}
                                              className="accordion-content" />
                        </div>

                        <div className={"accordion-item finish-shift-step" + (this.state.activeStep == 2 ? " active" : "")}>

                            <button disabled={this.state.lastCompletedStep >= 2 ? false : true} onClick={this.stepHeaderClick.bind(this, 2)} className="accordion-item-header">
                                <span className="step-nr">2</span>
                                <h2 className="step-title">Timesheet</h2>
                            </button>

                            <FinishShiftStep2 reports={reports} shift={shift}
                                              candidates={reportsReceived && candidatesReceived ? candidates : null}
                                              className="accordion-content" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default FinishShift;



/** WEBPACK FOOTER **
 ** ./app/src/views/FinishShift.js
 **/